import "./index.scss";
import { Button } from "@wise-emotions/react-button";
import { NewsEventsRelatedProps } from "./types";
import { parentDirectory } from "./utils";
import { useGetNewsEventsDetail } from "helpers/staticQueries/useGetNewsEventsDetail";
import Card07 from "components/Cards/Card07";
import CfList from "components/List/CfList";
import CtaReference from "components/CtaReference";
import React from "react";

const NewsEventsRelated = ({
  categories,
  node_locale,
  parentPath,
  translations,
}: NewsEventsRelatedProps) => {
  // TODO: test categories
  const { list } = useGetNewsEventsDetail(node_locale, categories, 3);

  let ctaPath;
  if (parentPath) {
    ctaPath = parentPath;
  } else {
    ctaPath =
      typeof window !== "undefined"
        ? parentDirectory(window.location.pathname)
        : "";
  }

  return (
    <div className="NewsEventsRelated wrapContent wrapContent-lg-lg">
      <div className="NewsEventsRelated__head">
        <h3 className="NewsEventsRelated__title">
          {translations?.title ?? ""}
        </h3>
        <div className="NewsEventsRelated__text">
          <p>{translations?.text ?? ""}</p>
        </div>
      </div>
      <div className="NewsEventsRelated__content">
        <CfList
          id="NewsEventsRelated__List"
          activeSlider="md"
          columnLayout={{
            default: "1",
            md: "3",
            lg: null,
            xl: null,
            sm: null,
          }}
        >
          {list.map((item) => {
            return (
              <div className="NewsEventsRelated__item" key={item.id}>
                <CtaReference
                  ctaType="internalStaticAutogenLink"
                  internalStaticLink={item.currentItemPageUrl}
                >
                  <Card07
                    abstract={item.abstract}
                    headingLabelType={item.contentType}
                    headingLabelInfo={item.date}
                    image={item.image}
                    labelCta={item.labelCtaPreview}
                    title={item.title}
                    contentful_id={item.contentful_id}
                  />
                </CtaReference>
              </div>
            );
          })}
        </CfList>
      </div>
      <div className="NewsEventsRelated__cta">
        <CtaReference
          ctaType="internalStaticAutogenLink"
          internalStaticLink={ctaPath}
        >
          <Button variant="default" size="lg">
            {translations?.ctaLabel ?? ""}
          </Button>
        </CtaReference>
      </div>
    </div>
  );
};

export default NewsEventsRelated;
